<template>
  <div>
    <b-row>
      <b-col lg="3">
        <InputMoney
          label="Base de cálculo"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :returnFormattedValue="false"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gCredPresOper.vBCCredPres"
        />
      </b-col>
      <b-col lg="6">
        <SelectWithSearch
          label="Cód. créd. Presumido"
          v-model="codCredPres"
          :filterBy="taxFilter"
          :change="changeCodCredPresSelected"
          :options="codCredPresCollection"
        >
          <template slot="options" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
          <template slot="no-options"> Nenhum resultado encontrado </template>
          <template slot="selected" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
        </SelectWithSearch>
      </b-col>
    </b-row>
    <CredPresOperIBS />
    <CredPresOperCBS />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { InputMoney, SelectWithSearch } from '@/components/Form';
import CredPresOperIBS from './CredPresOperIBS.vue';
import CredPresOperCBS from './CredPresOperCBS.vue';

export default {
  name: 'CredPresOper',
  components: {
    InputMoney,
    CredPresOperIBS,
    CredPresOperCBS,
    SelectWithSearch,
  },
  data() {
    return {
      codCredPres: null,
      taxFilter(option, _, search) {
        if (!search) return true;

        const searchToLower = search.toLowerCase();

        const codigoMatch = option.codigo
          ?.toString()
          .toLowerCase()
          .includes(searchToLower);
        const descricaoMatch = option.descricao
          ?.toString()
          .toLowerCase()
          .includes(searchToLower);

        return codigoMatch || descricaoMatch;
      },
    };
  },
  computed: {
    ...mapState('purchase', ['productOfPurchaseOnFiscalEdit']),
    ...mapState('ibsRegime', ['codCredPresCollection']),
  },
  mounted() {
    const codCredPres = this.codCredPresCollection.find(
      (e) =>
        e.codigo ===
        this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime?.gCredPresOper?.cCredPres,
    );

    if (codCredPres) {
      this.codCredPres = codCredPres;
    }
  },
  methods: {
    changeCodCredPresSelected(selectedCodCredPres) {
      if (selectedCodCredPres) {
        this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gCredPresOper.cCredPres =
          selectedCodCredPres.codigo;

        this.codCredPres = {
          ...selectedCodCredPres,
        };

        return;
      }

      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gCredPresOper.cCredPres = null;
      this.codCredPres = null;
    },
  },
};
</script>
